export default __webpack_public_path__ + "media/images/building_images/placeholder_1section_2-489c17483c7ee1567729431b3c825f7a.png";